import api from './Api';

export interface IEstoqueConciliacaoDecisao {
    id: number;
    contaEmpresa: string;
    descricao: string | null;
    mesCompetencia: number;
    anoCompetencia: number;
    saldoEstoque: number | null;
    saldoContabil: number;
    diferenca: number | null;
    reasonCode: string;
    contaSuspeita: string | null;
    valorClassificacaoIndevida: number | null;
    temInconsistenciaOrigem: boolean;
    orientacao: string | null;
    dataCriacao: string;
}

export interface IEstoquePosicaoGrupo {
    contaContabil: string;
    codGrupo: string;
    descGrupo: string | null;
    codGrupoSintetico: string | null;
    descGrupoSintetico: string | null;
    saldoInicial: number;
    recebimentoFornecedor: number;
    devolucaoFornecedor: number;
    entradaTransferencia: number;
    baixaTransferencia: number;
    baixaAcertoInventario: number;
    baixaPerdaEstrago: number;
    baixaCentroCusto: number;
    saldoAtual: number;
    diferencaEquacao: number;
}

export interface IEstoqueAnaliseEsteira {
    hotel: string | null;
    competencia: string | null;
    totalContas: number;
    totalConciliadas: number;
    saldoEstoqueTotal: number;
    saldoContabilTotal: number;
    divergenciaBrutaTotal: number;
    decisoes: IEstoqueConciliacaoDecisao[];
    grupos: IEstoquePosicaoGrupo[];
}

const EstoqueConciliacaoService = {
    buscarAnalise: async (esteiraId: number): Promise<IEstoqueAnaliseEsteira | null> => {
        try {
            const resp = await api.get(`estoque-conciliacao/${esteiraId}/analise`);
            return resp.data;
        } catch {
            return null;
        }
    },
};

export default EstoqueConciliacaoService;
